import { Constants } from '@pwc/pwc-deals-web-common';
import userTokenService from '../services/security/userTokenService';

export const canShowBasedOnStatus = (
  shareWithAll = false,
  isEditMode = false
): boolean => {
  let canShow = false;

  if (!shareWithAll) {
    canShow = true;
  }

  if (isEditMode) {
    canShow = true;
  }

  return canShow;
};

const showAutosync = async (
  projectId: string,
  isPwcUser: boolean
): Promise<boolean> => {
  const isPwcReadOnlyRole = Boolean(
    await userTokenService.hasProjectRoles(projectId, [
      Constants.USER_ROLES.PWC_READONLY_DISPLAY,
      Constants.USER_ROLES.PWC_READONLY,
    ])
  );
  return isPwcUser && !isPwcReadOnlyRole;
};

export default showAutosync;
